"use client";

export default function IsovLoader() {
  return (
    <div
      id="isov-loader"
      style={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        pointerEvents: "none",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        width="200"
        height="200"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
      >
        <circle
          fill="#E7E8EF"
          stroke="#E7E8EF"
          strokeWidth="3"
          cx="8"
          cy="54"
          r="6"
        >
          <animateTransform
            attributeName="transform"
            dur="2s"
            type="rotate"
            from="0 50 48"
            to="360 50 52"
            repeatCount="indefinite"
          />
        </circle>

        <g style={{ transform: "translate(30%, 30%)" }}>
          <path
            clipRule="evenodd"
            d="m30.6545.688568h-20.4363l-10.2182 17.209332 10.2182 17.2092h20.4363l10.2184-17.2092zm-5.2545 8.849702h-9.9272l-4.9636 8.35963 4.9636 8.3597h9.9272l4.9635-8.3597z"
            fill="#0078fb"
            fillRule="evenodd"
          />
          <path
            d="m17.4589 12.8763h5.9239l2.962 4.9884-2.962 4.9884h-5.9239l-2.9619-4.9884z"
            fill="#737373"
          />
          <path
            d="m23.3856 22.8561-2.9238-4.9884-3.0001 4.9884z"
            fill="#464646"
          />
          <path d="m23.3856 12.8763h-5.9239l3.0001 4.9884z" fill="#c7c7c7" />
          <path
            d="m23.3828 12.8763-2.9238 4.9884h5.9011zm-2.9238 4.9884-3.0001-4.9884-2.9619 4.9884z"
            fill="#989898"
          />
          <path
            d="m30.6514 35.1075 10.2184-17.2093h-10.5093l-4.9636 8.3597z"
            fill="#0058fb"
          />
          <path d="m30.6514 35.1077 5.2547-8.8495h-10.5092z" fill="#0078fb" />
          <path d="m35.9274 9.54021h-10.5305l4.9636 8.35959z" fill="#4cbafb" />
          <path d="m35.929 9.54959-5.5669 8.34741h10.5093z" fill="#9ddafb" />
          <path
            d="m20.4364 35.1077 4.9636-8.8495 5.2545 8.8495z"
            fill="#0069e4"
          />
          <path
            d="m-.00000763 17.8982h10.50920763l-5.54561 8.3597h10.50921l5.1151 8.8496h-10.3697l-5.25461-8.8496z"
            fill="#0101d7"
          />
          <path
            clipRule="evenodd"
            d="m10.5092 17.8998-5.52615-8.35959-4.98305763 8.35959h10.50920763l4.9636 8.3597h-10.48975z"
            fill="#0035fb"
            fillRule="evenodd"
          />
          <path
            d="m25.3984 9.53827-4.8121-8.849702-5.1151 8.849702z"
            fill="#0027fb"
          />
          <path d="m30.6514.688568-5.2545 8.849702h10.5305z" fill="#37a0fb" />
        </g>
      </svg>
    </div>
  );
}
